"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ciKeywordsApi = void 0;
const createApi_1 = require("../../helpers/createApi");
const searchContentInterest = (caller) => (options) => {
    const { accountId, valueSearch, timeframe } = options;
    const url = `/backend/accounts/${accountId}/ci_keywords?pattern=${valueSearch}&timeframe=${timeframe}`;
    return caller(url).get();
};
const listContentInterestV2 = (caller) => ({ accountId, filters = {}, page }) => {
    const url = `/backend/accounts/${accountId}/ci_keywords`;
    return caller(url).get({
        ...filters,
        page,
    });
};
const getContentInterestKeywords = (caller) => ({ accountId }) => {
    return caller(`/backend/accounts/${accountId}/most_relevant_keywords`).get();
};
exports.ciKeywordsApi = (0, createApi_1.createAPIFactory)({
    searchContentInterest,
    getContentInterestKeywords,
    listContentInterestV2,
});
//# sourceMappingURL=api.js.map